(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel-oct1dev1"] && !Shopify.designMode) return;
  try {
    
  // Override carousel behavior to move one slide at a time
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.section-resource-list .resource-list__carousel slideshow-component');
    if (carousel) {
      // Override the next and previous methods to move only one slide
      const originalNext = carousel.next;
      const originalPrevious = carousel.previous;
      
      carousel.next = function(event, options) {
        // Move only one slide instead of the default behavior
        const currentIndex = this.current;
        this.select(currentIndex + 1, event, options);
      };
      
      carousel.previous = function(event, options) {
        // Move only one slide instead of the default behavior
        const currentIndex = this.current;
        this.select(currentIndex - 1, event, options);
      };

      // Add dot navigation functionality with improved event handling
      const dots = document.querySelectorAll('.section-resource-list .slideshow-dot');
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          console.log('Dot clicked:', index);
          
          // Remove active class from all dots
          dots.forEach(d => d.classList.remove('active'));
          // Add active class to clicked dot
          this.classList.add('active');
          
          // Go to selected slide with multiple approaches
          if (carousel) {
            try {
              // Method 1: Direct select
              if (typeof carousel.select === 'function') {
                carousel.select(index);
                console.log('Carousel select called for index:', index);
              }
              
              // Method 2: Set current and trigger change
              setTimeout(() => {
                if (carousel.current !== index) {
                  carousel.current = index;
                  console.log('Carousel current set to:', index);
                  
                  // Trigger a custom event to ensure carousel updates
                  const changeEvent = new CustomEvent('carousel:change', {
                    detail: { index: index }
                  });
                  carousel.dispatchEvent(changeEvent);
                }
              }, 50);
              
            } catch (error) {
              console.error('Error navigating to slide:', error);
            }
          }
        });
      });

      // Add arrow navigation functionality - completely rewritten
      const prevButton = document.querySelector('.section-resource-list .slideshow-control--prev');
      const nextButton = document.querySelector('.section-resource-list .slideshow-control--next');
      
      console.log('Found prev button:', prevButton);
      console.log('Found next button:', nextButton);
      console.log('Found carousel:', carousel);
      
      if (nextButton) {
        console.log('Setting up Next button with new approach...');
        
        // Try multiple event binding approaches
        nextButton.addEventListener('mousedown', function(event) {
          event.preventDefault();
          event.stopPropagation();
          console.log('Next button mousedown detected!');
        });
        
        nextButton.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          console.log('Next button click detected!');
          
          // Try to find the carousel in multiple ways
          let slideshowComponent = document.querySelector('.section-resource-list slideshow-component');
          if (!slideshowComponent) {
            slideshowComponent = document.querySelector('slideshow-component');
          }
          if (!slideshowComponent) {
            slideshowComponent = document.querySelector('[ref="resourceListCarousel"]');
          }
          
          console.log('Found slideshow component:', slideshowComponent);
          
          if (slideshowComponent) {
            console.log('Slideshow component properties:', {
              current: slideshowComponent.current,
              slides: slideshowComponent.slides,
              select: typeof slideshowComponent.select
            });
            
            const currentIndex = slideshowComponent.current || 0;
            const newIndex = currentIndex < 4 ? currentIndex + 1 : 0;
            console.log('Attempting to move from slide', currentIndex, 'to slide', newIndex);
            
            // Try multiple methods to move the carousel
            if (typeof slideshowComponent.select === 'function') {
              slideshowComponent.select(newIndex);
              console.log('Method 1: select() called');
            } else if (typeof slideshowComponent.next === 'function') {
              slideshowComponent.next();
              console.log('Method 2: next() called');
            } else if (slideshowComponent.slides && slideshowComponent.slides.length > 0) {
              slideshowComponent.current = newIndex;
              console.log('Method 3: current property set');
            }
            
            // Update dot navigation
            updateActiveDot(newIndex);
          } else {
            console.error('No slideshow component found');
          }
        });
        
        // Also try direct onclick
        nextButton.onclick = function(event) {
          console.log('Next button onclick triggered!');
        };
        
        console.log('Next button event handlers set');
      }

      // Update active dot when carousel slides change - only for main carousel
      carousel.addEventListener('slideshow:select', function(event) {
        // Only update dots if this is the main carousel, not product card slideshow
        if (event.target === carousel) {
          const currentIndex = event.detail.index;
          console.log('Main carousel slideshow:select event - index:', currentIndex);
          updateActiveDot(currentIndex);
        }
      });

      carousel.addEventListener('change', function(event) {
        // Only update dots if this is the main carousel, not product card slideshow
        if (event.target === carousel) {
          const currentIndex = carousel.current || 0;
          console.log('Main carousel change event - index:', currentIndex);
          updateActiveDot(currentIndex);
        }
      });

      // Listen for custom carousel change event - only for main carousel
      carousel.addEventListener('carousel:change', function(event) {
        // Only update dots if this is the main carousel, not product card slideshow
        if (event.target === carousel) {
          const currentIndex = event.detail.index;
          console.log('Main carousel:change event - index:', currentIndex);
          updateActiveDot(currentIndex);
        }
      });

      // Function to update active dot
      function updateActiveDot(index) {
        dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) {
            dot.classList.add('active');
            console.log('Dot', dotIndex, 'set to active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      // Function to update arrow visibility based on current slide
      function updateArrowVisibility(currentIndex) {
        const prevButton = document.querySelector('.section-resource-list .slideshow-control--prev');
        const nextButton = document.querySelector('.section-resource-list .slideshow-control--next');
        
        // Calculate the last slide index based on number of products
        const navContainer = document.querySelector('.section-resource-list .slideshow-navigation-container');
        const totalProducts = navContainer ? parseInt(navContainer.dataset.totalProducts) : 8;
        const productsPerView = navContainer ? parseInt(navContainer.dataset.productsPerView) : 4;
        const lastSlideIndex = Math.max(0, totalProducts - productsPerView);
        
        console.log('Updating arrow visibility for slide:', currentIndex, 'Last slide:', lastSlideIndex, 'Total products:', totalProducts);
        
        if (prevButton && nextButton) {
          // Hide Previous button if on first slide (index 0)
          if (currentIndex === 0) {
            prevButton.style.opacity = '0';
            prevButton.style.pointerEvents = 'none';
            prevButton.style.visibility = 'hidden';
            console.log('Previous button hidden (first slide)');
          } else {
            prevButton.style.opacity = '1';
            prevButton.style.pointerEvents = 'auto';
            prevButton.style.visibility = 'visible';
            console.log('Previous button visible');
          }
          
          // Hide Next button if on last slide
          if (currentIndex >= lastSlideIndex) {
            nextButton.style.opacity = '0';
            nextButton.style.pointerEvents = 'none';
            nextButton.style.visibility = 'hidden';
            console.log('Next button hidden (last slide)');
          } else {
            nextButton.style.opacity = '1';
            nextButton.style.pointerEvents = 'auto';
            nextButton.style.visibility = 'visible';
            console.log('Next button visible');
          }
        } else {
          console.error('Arrow buttons not found:', { prevButton, nextButton });
        }
      }

      // Initial dot state and arrow visibility
      setTimeout(() => {
        const initialIndex = carousel.current || 0;
        console.log('Setting initial dot state to index:', initialIndex);
        updateActiveDot(initialIndex);
        
        // Debug: Check if Previous button exists
        const prevButton = document.querySelector('.section-resource-list .slideshow-control--prev');
        const nextButton = document.querySelector('.section-resource-list .slideshow-control--next');
        console.log('Found Previous button:', prevButton);
        console.log('Found Next button:', nextButton);
        
        updateArrowVisibility(initialIndex);
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel-worktheme"] && !Shopify.designMode) return;
  try {
    
  // Override carousel behavior to move one slide at a time
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.section-resource-list .resource-list__carousel slideshow-component');
    if (carousel) {
      // Override the next and previous methods to move only one slide
      const originalNext = carousel.next;
      const originalPrevious = carousel.previous;
      
      carousel.next = function(event, options) {
        // Move only one slide instead of the default behavior
        const currentIndex = this.current;
        this.select(currentIndex + 1, event, options);
      };
      
      carousel.previous = function(event, options) {
        // Move only one slide instead of the default behavior
        const currentIndex = this.current;
        this.select(currentIndex - 1, event, options);
      };

      // Add dot navigation functionality with improved event handling
      const dots = document.querySelectorAll('.section-resource-list .slideshow-dot');
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          console.log('Dot clicked:', index);
          
          // Remove active class from all dots
          dots.forEach(d => d.classList.remove('active'));
          // Add active class to clicked dot
          this.classList.add('active');
          
          // Go to selected slide with multiple approaches
          if (carousel) {
            try {
              // Method 1: Direct select
              if (typeof carousel.select === 'function') {
                carousel.select(index);
                console.log('Carousel select called for index:', index);
              }
              
              // Method 2: Set current and trigger change
              setTimeout(() => {
                if (carousel.current !== index) {
                  carousel.current = index;
                  console.log('Carousel current set to:', index);
                  
                  // Trigger a custom event to ensure carousel updates
                  const changeEvent = new CustomEvent('carousel:change', {
                    detail: { index: index }
                  });
                  carousel.dispatchEvent(changeEvent);
                }
              }, 50);
              
            } catch (error) {
              console.error('Error navigating to slide:', error);
            }
          }
        });
      });

      // Add arrow navigation functionality - completely rewritten
      const prevButton = document.querySelector('.section-resource-list .slideshow-control--prev');
      const nextButton = document.querySelector('.section-resource-list .slideshow-control--next');
      
      console.log('Found prev button:', prevButton);
      console.log('Found next button:', nextButton);
      console.log('Found carousel:', carousel);
      
      if (nextButton) {
        console.log('Setting up Next button with new approach...');
        
        // Try multiple event binding approaches
        nextButton.addEventListener('mousedown', function(event) {
          event.preventDefault();
          event.stopPropagation();
          console.log('Next button mousedown detected!');
        });
        
        nextButton.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          console.log('Next button click detected!');
          
          // Try to find the carousel in multiple ways
          let slideshowComponent = document.querySelector('.section-resource-list slideshow-component');
          if (!slideshowComponent) {
            slideshowComponent = document.querySelector('slideshow-component');
          }
          if (!slideshowComponent) {
            slideshowComponent = document.querySelector('[ref="resourceListCarousel"]');
          }
          
          console.log('Found slideshow component:', slideshowComponent);
          
          if (slideshowComponent) {
            console.log('Slideshow component properties:', {
              current: slideshowComponent.current,
              slides: slideshowComponent.slides,
              select: typeof slideshowComponent.select
            });
            
            const currentIndex = slideshowComponent.current || 0;
            const newIndex = currentIndex < 4 ? currentIndex + 1 : 0;
            console.log('Attempting to move from slide', currentIndex, 'to slide', newIndex);
            
            // Try multiple methods to move the carousel
            if (typeof slideshowComponent.select === 'function') {
              slideshowComponent.select(newIndex);
              console.log('Method 1: select() called');
            } else if (typeof slideshowComponent.next === 'function') {
              slideshowComponent.next();
              console.log('Method 2: next() called');
            } else if (slideshowComponent.slides && slideshowComponent.slides.length > 0) {
              slideshowComponent.current = newIndex;
              console.log('Method 3: current property set');
            }
            
            // Update dot navigation
            updateActiveDot(newIndex);
          } else {
            console.error('No slideshow component found');
          }
        });
        
        // Also try direct onclick
        nextButton.onclick = function(event) {
          console.log('Next button onclick triggered!');
        };
        
        console.log('Next button event handlers set');
      }

      // Update active dot when carousel slides change - only for main carousel
      carousel.addEventListener('slideshow:select', function(event) {
        // Only update dots if this is the main carousel, not product card slideshow
        if (event.target === carousel) {
          const currentIndex = event.detail.index;
          console.log('Main carousel slideshow:select event - index:', currentIndex);
          updateActiveDot(currentIndex);
        }
      });

      carousel.addEventListener('change', function(event) {
        // Only update dots if this is the main carousel, not product card slideshow
        if (event.target === carousel) {
          const currentIndex = carousel.current || 0;
          console.log('Main carousel change event - index:', currentIndex);
          updateActiveDot(currentIndex);
        }
      });

      // Listen for custom carousel change event - only for main carousel
      carousel.addEventListener('carousel:change', function(event) {
        // Only update dots if this is the main carousel, not product card slideshow
        if (event.target === carousel) {
          const currentIndex = event.detail.index;
          console.log('Main carousel:change event - index:', currentIndex);
          updateActiveDot(currentIndex);
        }
      });

      // Function to update active dot
      function updateActiveDot(index) {
        dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) {
            dot.classList.add('active');
            console.log('Dot', dotIndex, 'set to active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      // Function to update arrow visibility based on current slide
      function updateArrowVisibility(currentIndex) {
        const prevButton = document.querySelector('.section-resource-list .slideshow-control--prev');
        const nextButton = document.querySelector('.section-resource-list .slideshow-control--next');
        
        // Calculate the last slide index based on number of products
        const navContainer = document.querySelector('.section-resource-list .slideshow-navigation-container');
        const totalProducts = navContainer ? parseInt(navContainer.dataset.totalProducts) : 8;
        const productsPerView = navContainer ? parseInt(navContainer.dataset.productsPerView) : 4;
        const lastSlideIndex = Math.max(0, totalProducts - productsPerView);
        
        console.log('Updating arrow visibility for slide:', currentIndex, 'Last slide:', lastSlideIndex, 'Total products:', totalProducts);
        
        if (prevButton && nextButton) {
          // Hide Previous button if on first slide (index 0)
          if (currentIndex === 0) {
            prevButton.style.opacity = '0';
            prevButton.style.pointerEvents = 'none';
            prevButton.style.visibility = 'hidden';
            console.log('Previous button hidden (first slide)');
          } else {
            prevButton.style.opacity = '1';
            prevButton.style.pointerEvents = 'auto';
            prevButton.style.visibility = 'visible';
            console.log('Previous button visible');
          }
          
          // Hide Next button if on last slide
          if (currentIndex >= lastSlideIndex) {
            nextButton.style.opacity = '0';
            nextButton.style.pointerEvents = 'none';
            nextButton.style.visibility = 'hidden';
            console.log('Next button hidden (last slide)');
          } else {
            nextButton.style.opacity = '1';
            nextButton.style.pointerEvents = 'auto';
            nextButton.style.visibility = 'visible';
            console.log('Next button visible');
          }
        } else {
          console.error('Arrow buttons not found:', { prevButton, nextButton });
        }
      }

      // Initial dot state and arrow visibility
      setTimeout(() => {
        const initialIndex = carousel.current || 0;
        console.log('Setting initial dot state to index:', initialIndex);
        updateActiveDot(initialIndex);
        
        // Debug: Check if Previous button exists
        const prevButton = document.querySelector('.section-resource-list .slideshow-control--prev');
        const nextButton = document.querySelector('.section-resource-list .slideshow-control--next');
        console.log('Found Previous button:', prevButton);
        console.log('Found Next button:', nextButton);
        
        updateArrowVisibility(initialIndex);
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  // Override carousel behavior to move one slide at a time
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.section-resource-list .resource-list__carousel slideshow-component');
    if (carousel) {
      // Override the next and previous methods to move only one slide
      const originalNext = carousel.next;
      const originalPrevious = carousel.previous;
      
      carousel.next = function(event, options) {
        // Move only one slide instead of the default behavior
        const currentIndex = this.current;
        this.select(currentIndex + 1, event, options);
      };
      
      carousel.previous = function(event, options) {
        // Move only one slide instead of the default behavior
        const currentIndex = this.current;
        this.select(currentIndex - 1, event, options);
      };

      // Add dot navigation functionality with improved event handling
      const dots = document.querySelectorAll('.section-resource-list .slideshow-dot');
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          
          // Remove active class from all dots
          dots.forEach(d => d.classList.remove('active'));
          // Add active class to clicked dot
          this.classList.add('active');
          
          // Go to selected slide with multiple approaches
          if (carousel) {
            try {
              // Method 1: Direct select
              if (typeof carousel.select === 'function') {
                carousel.select(index);
              }
              
              // Method 2: Set current and trigger change
              setTimeout(() => {
                if (carousel.current !== index) {
                  carousel.current = index;
                  
                  // Trigger a custom event to ensure carousel updates
                  const changeEvent = new CustomEvent('carousel:change', {
                    detail: { index: index }
                  });
                  carousel.dispatchEvent(changeEvent);
                }
              }, 50);
              
            } catch (error) {
            }
          }
        });
      });

      // Add arrow navigation functionality - completely rewritten
      const prevButton = document.querySelector('.section-resource-list .slideshow-control--prev');
      const nextButton = document.querySelector('.section-resource-list .slideshow-control--next');
      
      
      if (nextButton) {
        
        // Try multiple event binding approaches
        nextButton.addEventListener('mousedown', function(event) {
          event.preventDefault();
          event.stopPropagation();
        });
        
        nextButton.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          
          // Try to find the carousel in multiple ways
          let slideshowComponent = document.querySelector('.section-resource-list slideshow-component');
          if (!slideshowComponent) {
            slideshowComponent = document.querySelector('slideshow-component');
          }
          if (!slideshowComponent) {
            slideshowComponent = document.querySelector('[ref="resourceListCarousel"]');
          }
          
          
          if (slideshowComponent) {
            
            const currentIndex = slideshowComponent.current || 0;
            const newIndex = currentIndex < 4 ? currentIndex + 1 : 0;
            
            // Try multiple methods to move the carousel
            if (typeof slideshowComponent.select === 'function') {
              slideshowComponent.select(newIndex);
            } else if (typeof slideshowComponent.next === 'function') {
              slideshowComponent.next();
            } else if (slideshowComponent.slides && slideshowComponent.slides.length > 0) {
              slideshowComponent.current = newIndex;
            }
            
            // Update dot navigation
            updateActiveDot(newIndex);
          } else {
          }
        });
        
        // Also try direct onclick
        nextButton.onclick = function(event) {
        };
        
      }

      // Update active dot when carousel slides change - only for main carousel
      carousel.addEventListener('slideshow:select', function(event) {
        // Only update dots if this is the main carousel, not product card slideshow
        if (event.target === carousel) {
          const currentIndex = event.detail.index;
          updateActiveDot(currentIndex);
        }
      });

      carousel.addEventListener('change', function(event) {
        // Only update dots if this is the main carousel, not product card slideshow
        if (event.target === carousel) {
          const currentIndex = carousel.current || 0;
          updateActiveDot(currentIndex);
        }
      });

      // Listen for custom carousel change event - only for main carousel
      carousel.addEventListener('carousel:change', function(event) {
        // Only update dots if this is the main carousel, not product card slideshow
        if (event.target === carousel) {
          const currentIndex = event.detail.index;
          updateActiveDot(currentIndex);
        }
      });

      // Function to update active dot
      function updateActiveDot(index) {
        dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }

      // Function to update arrow visibility based on current slide
      function updateArrowVisibility(currentIndex) {
        const prevButton = document.querySelector('.section-resource-list .slideshow-control--prev');
        const nextButton = document.querySelector('.section-resource-list .slideshow-control--next');
        
        // Calculate the last slide index based on number of products
        const navContainer = document.querySelector('.section-resource-list .slideshow-navigation-container');
        const totalProducts = navContainer ? parseInt(navContainer.dataset.totalProducts) : 8;
        const productsPerView = navContainer ? parseInt(navContainer.dataset.productsPerView) : 4;
        const lastSlideIndex = Math.max(0, totalProducts - productsPerView);
        
        
        if (prevButton && nextButton) {
          // Hide Previous button if on first slide (index 0)
          if (currentIndex === 0) {
            prevButton.style.opacity = '0';
            prevButton.style.pointerEvents = 'none';
            prevButton.style.visibility = 'hidden';
          } else {
            prevButton.style.opacity = '1';
            prevButton.style.pointerEvents = 'auto';
            prevButton.style.visibility = 'visible';
          }
          
          // Hide Next button if on last slide
          if (currentIndex >= lastSlideIndex) {
            nextButton.style.opacity = '0';
            nextButton.style.pointerEvents = 'none';
            nextButton.style.visibility = 'hidden';
          } else {
            nextButton.style.opacity = '1';
            nextButton.style.pointerEvents = 'auto';
            nextButton.style.visibility = 'visible';
          }
        } else {
        }
      }

      // Initial dot state and arrow visibility
      setTimeout(() => {
        const initialIndex = carousel.current || 0;
        updateActiveDot(initialIndex);
        
        // Debug: Check if Previous button exists
        const prevButton = document.querySelector('.section-resource-list .slideshow-control--prev');
        const nextButton = document.querySelector('.section-resource-list .slideshow-control--next');
        
        updateArrowVisibility(initialIndex);
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
